import React from "react";
import { MiniBarChart, Panel } from "../../components/ui/dashboard";

const Reports: React.FC = () => {
  return (
    <div className="p-4 md:p-6 grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Panel title="Revenue Report" subtitle="Monthly collection">
        <MiniBarChart values={[25, 35, 45, 55, 70, 82, 74]} />
      </Panel>
      <Panel title="Charge Composition" subtitle="Freight vs other charges">
        <MiniBarChart values={[70, 22, 30, 15, 18, 10, 12]} />
      </Panel>
    </div>
  );
};

export default Reports;